import moment from "moment"

export const convertDateExport = (datetime: string) =>
  moment(datetime).utc().format("YYYYMMDD")
